export const AutoCaptureHintsEnum = {
    MISNAP_HEAD_OUTSIDE: 'Slowly place Face in Oval',
    MISNAP_HEAD_SKEWED: 'Look Straight Ahead',
    MISNAP_AXIS_ANGLE: 'Hold Phone Upright',
    MISNAP_HEAD_TOO_CLOSE: 'Slowly move farther away',
    MISNAP_HEAD_TOO_FAR: 'Get Closer',
    MISNAP_STAY_STILL: 'Hold Still',
    MISNAP_SUCCESS: 'Success',
    MISNAP_STOP_SMILING: 'Stop Smiling',
    MISNAP_SMILE: 'Hold a smile',
    MISNAP_READY_POSE: 'Hold it There',
    NO_FACE_FOUND: 'Detecting face please wait',
    MITEK_ERROR_GLARE: 'Reduce Glare',
    MITEK_ERROR_FOUR_CORNER: 'Document Not Found',
    MITEK_ERROR_TOO_DARK: 'Too Dark. Use good lighting',
    MITEK_ERROR_FOCUS: 'Hold Steady',
    CV_NO_BARCODE_FOUND: 'Scanning for barcode',
    MITEK_ERROR_TOO_FAR: 'Document Too Far',
    MITEK_ERROR_TOO_CLOSE: 'Document Too Close',
    MITEK_ERROR_NOT_CENTERED: 'Document Not Centered',
    MITEK_ERROR_MIN_PADDING: 'Slowly move further away',
    MITEK_ERROR_HORIZONTAL_FILL: 'Slowly move closer',
    MITEK_ERROR_LOW_CONTRAST: 'Center document on a dark background',
    MITEK_ERROR_BUSY_BACKGROUND: 'Center document on a plain background',
    MITEK_ERROR_SKEW_ANGLE: 'Reduce angle',
    MITEK_ERROR_PERPENDICULAR_DOCUMENT: 'Change orientation of your document',
};
//# sourceMappingURL=types.js.map